import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Resolve} from '@angular/router';
import { GeneralService } from '../../services/general.service';
import { DataService } from '../services/data.service';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DataGuard implements Resolve<any> {

  parametros: any;
  unidades: any;
  unidadesOtros: any;

  constructor(
    private generalService: GeneralService,
    private dataService: DataService,
    private router: Router,
    @Inject(PLATFORM_ID) public platformId: Object

  ) { }

  async resolve(): Promise<any> {

    if (isPlatformBrowser(this.platformId)) {
      
      this.dataService.currentParametros.subscribe(parametros => this.parametros = parametros)
      this.dataService.currentUnidades.subscribe(unidades => this.unidades = unidades);
      this.dataService.currentOtrosUnidades.subscribe(unidades => this.unidadesOtros = unidades);

      if ((this.parametros === null || this.parametros === '') && this.unidades.length === 0 && this.unidadesOtros.length === 0) {
        const parameter = await this.generalService.parametros();
        const unit = await this.generalService.unidades(1);
        const unitOtros = await this.generalService.unidadesOtros(1);

        if (parameter['codigo'] === 1 && unit['codigo'] === 1 && unitOtros['codigo'] === 1) {
          this.dataService.changeParametros(parameter['data']);
          this.dataService.changeUnidades(unit['data']);
          this.dataService.changeUnidadesOtros(unitOtros['data']);
          return true;
        } else {
          this.router.navigate(['home']);
          return false;
        }

      } else {
        return true;
      }
    }

  }
}
